/**
 * Per-bank kebab menu (used on cards + the detail header).
 *
 * Extracted verbatim from QuestionBanksPage.jsx during the Phase 5 refactor
 * (no behaviour change).
 */
import { Button } from '../ui/button';
import {
  DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator,
} from '../ui/dropdown-menu';
import { Trash2, Pencil, MoreVertical, Copy as CopyIcon, Archive, CheckCircle2 } from 'lucide-react';

export function BankActionsMenu({ bank, onEdit, onDuplicate, onRetire, onDelete, onPublishItems = null, triggerSize = 'sm' }) {
  const canRetire = bank.lifecycle_status !== 'retired';
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className={triggerSize === 'sm' ? 'h-7 w-7' : 'h-9 w-9'}
          onClick={(e) => e.stopPropagation()}
          data-testid={`bank-kebab-${bank.bank_id}`}
          aria-label="Bank actions"
        >
          <MoreVertical className="w-4 h-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" onClick={(e) => e.stopPropagation()}>
        <DropdownMenuItem onClick={() => onEdit(bank)} data-testid={`bank-edit-${bank.bank_id}`}>
          <Pencil className="w-3.5 h-3.5 mr-2" />Edit details
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => onDuplicate(bank)} data-testid={`bank-duplicate-${bank.bank_id}`}>
          <CopyIcon className="w-3.5 h-3.5 mr-2" />Duplicate
        </DropdownMenuItem>
        {onPublishItems && (
          <DropdownMenuItem onClick={() => onPublishItems(bank)} data-testid={`bank-publish-items-${bank.bank_id}`}>
            <CheckCircle2 className="w-3.5 h-3.5 mr-2" />Publish all items
          </DropdownMenuItem>
        )}
        {canRetire && (
          <DropdownMenuItem onClick={() => onRetire(bank)} data-testid={`bank-retire-${bank.bank_id}`}>
            <Archive className="w-3.5 h-3.5 mr-2" />Retire
          </DropdownMenuItem>
        )}
        <DropdownMenuSeparator />
        <DropdownMenuItem
          onClick={() => onDelete(bank)}
          className="text-red-600 focus:text-red-600 focus:bg-red-50 dark:focus:bg-red-950/40"
          data-testid={`bank-delete-${bank.bank_id}`}
        >
          <Trash2 className="w-3.5 h-3.5 mr-2" />Delete
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
